
import classNames from 'classnames';
import './styles.scss';

const ImageCarousel = ({
    images,
    ...props
}) => {
    return (
        <div className="image-carousel">
            <div className="image-carousel__scroller" ref={props.imageCarouselScrollerRef}>
                {images && images.map((image, index) => {
                    
                    const src = props.useMediumImages && image.sizes && image.sizes.medium ? image.sizes.medium.url : image.src;



                    return (
                        <div key={index} className="image-carousel__image">
                            <img src={src} alt={image.alt} title={image.title} {...props.lazyLoadAttribute} />
                        </div>
                    );
                })}
            </div>
     
            {props.hideNavigation !== true && (images && images.length > 1) &&
                <div className="image-carousel__pages-container" ref={props.imageCarouselContainerPagesRef}>
                    <ul 
                        className="image-carousel__pages"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}>
                        {images && images.map((image, index) => {
                            return (
                                <li 
                                    key={`page-${index}`} 
                                    className={classNames({
                                        'image-carousel__page': true,
                                        'image-carousel__page--selected': index === (props.imageCarouselState ? props.imageCarouselState.currentIndex : 0)
                                    })}>
                                    <button 
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            if (props.scrollToIndex) {
                                                props.scrollToIndex(index);
                                            }
                                        }}></button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            }
        </div>
    );
};

export default ImageCarousel;